module.exports = __webpack_public_path__ + "img/2.b37b8430.png";